import { createContext, useContext, useEffect, useRef, useState } from 'react';
import Lenis from 'lenis';

const LenisContext = createContext(null);
export const useLenis = () => useContext(LenisContext);

export default function LenisProvider({ children }) {
	const lenisRef = useRef(null);
	const [lenisInstance, setLenisInstance] = useState(null);

	useEffect(() => {
		const lenis = new Lenis({
			duration: 1.5,
			smoothWheel: true,
			smoothTouch: true,
			lerp: 0.1 // smoothness strength
		});

		lenisRef.current = lenis;
		setLenisInstance(lenis); //important (makes context reactive)

		function raf(time) {
			lenis.raf(time);
			requestAnimationFrame(raf);
		}

		requestAnimationFrame(raf);

		// React + lazy pages height fix
		const resizeObserver = new ResizeObserver(() => {
			lenis.resize();
		});

		resizeObserver.observe(document.body);

		return () => {
			resizeObserver.disconnect();
			lenis.destroy();
		};
	}, []);

	return (
		<LenisContext.Provider value={lenisInstance}>
			{children}
		</LenisContext.Provider>
	);
}

// import { createContext, useContext, useEffect, useRef, useState } from 'react'
// import Lenis from 'lenis'
// import { gsap } from 'gsap'
// import { ScrollTrigger } from 'gsap/ScrollTrigger'

// gsap.registerPlugin(ScrollTrigger)

// const LenisContext = createContext(null)
// export const useLenis = () => useContext(LenisContext)

// export default function LenisProvider({ children }) {
// 	const lenisRef = useRef(null);
// 	const [lenisInstance, setLenisInstance] = useState(null);

// 	useEffect(() => {
// 		const lenis = new Lenis({
// 			duration: 1.2,
// 			smoothWheel: true,
// 			smoothTouch: true,
// 			lerp: 0.1
// 		})

// 		lenisRef.current = lenis
// 		setLenisInstance(lenis)

// 		//Sync Lenis with GSAP
// 		lenis.on('scroll', ScrollTrigger.update)

// 		gsap.ticker.add((time) => {
// 			lenis.raf(time * 1000)
// 		})

// 		gsap.ticker.lagSmoothing(0)

// 		// Resize handling
// 		const resizeObserver = new ResizeObserver(() => {
// 			lenis.resize()
// 			ScrollTrigger.refresh()
// 		})

// 		resizeObserver.observe(document.body)

// 		return () => {
// 			resizeObserver.disconnect()
// 			lenis.destroy()
// 			gsap.ticker.remove(lenis.raf)
// 		}
// 	}, [])

// 	return (
// 		<LenisContext.Provider value={lenisInstance}>
// 			{children}
// 		</LenisContext.Provider>
// 	);
// };
